"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.readCookies = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const generate_session_id_1 = require("@jsmdg/generate-session-id");
const demandwareCookieId = {
    JS_DE: 'fd1641b66520bcd992879f076d43c4bb',
    JS_AT: '8ce8f2a04218cab45b5909f1ff0bbaa6',
};
function readCookies(tenant) {
    const evelinCustomerId = js_cookie_1.default.get(generate_session_id_1.TRACKING_CLIENT_ID_COOKIE_CONFIG.name);
    const evelinSessionId = js_cookie_1.default.get(generate_session_id_1.TRACKING_SESSION_ID_COOKIE_CONFIG.name);
    const demandwareCustomerIdCookieName = `dwanonymous_${demandwareCookieId[tenant]}`;
    const demandwareCustomerId = js_cookie_1.default.get(demandwareCustomerIdCookieName);
    const demandwareSessionId = js_cookie_1.default.get('sid');
    return {
        demandwareCustomerId,
        demandwareSessionId,
        evelinCustomerId,
        evelinSessionId,
    };
}
exports.readCookies = readCookies;
//# sourceMappingURL=readCookies.js.map